import { api } from "./api/apiSlice";

export interface MemberFee {
  id: string;
  membership_type_id: string;
  membership_fee?: string;
  membership_fee_effective_date?: string; // This will be in YYYY-MM-DD format
  subscription_fee?: string;
  subscription_fee_effective_date?: string; // This will be in YYYY-MM-DD format
  created_at?: string;
  updated_at?: string;
}

export interface MembershipType {
  id: string;
  name: string;
  amount: string;
  member_fees?: MemberFee[];
}

export const membershipApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMembershipTypes: builder.query<MembershipType[], void>({
      query: () => "membership-types/",
    }),
  }),
});

export const { useGetMembershipTypesQuery } = membershipApi;
